/**
 * @description 防抖函数
 * @author xiaoxin
 * @date 2018-12-03
 * @export
 * @param {*} func
 * @param {*} wait
 * @param {*} mustRun
 * @returns
 */
export default function (func, wait = 60, mustRun = 100) {
    let timeout,
        startTime = new Date();

    return function() {
        let context = this,
            args = arguments,
            curTime = new Date();
		if(timeout){
			clearTimeout(timeout);
			timeout = null;
		}
        if(curTime - startTime >= mustRun){
            func.apply(context,args);
            startTime = curTime;
        }else{
            timeout = setTimeout(()=>{
                func.apply(context,args);
            }, wait);
        }
    };
};